<template>
    <section class="page6">
        <div class="top-image">
            <img src="~@/assets/img/section-top.png" alt="" />
        </div>
        <div class="conteudo-reverse text-left">
            <div class="col1"></div>
            <div class="col2">
                <div class="articleColumn" :class="{ active: isSelected }">
                    <div class="articleRow index-2" data-aos="fade-up">
                        <div>
                            <img
                                class="top-complete"
                                src="~@/assets/img/blue-left.png"
                                alt=""
                            />
                        </div>
                        <div class="articleColumn-top">
                            <p class="text-white text-bigger text-bold">
                                <i
                                    >“O RH trata e cuida de muitos dados
                                    sensíveis na empresa.”</i
                                >
                            </p>
                        </div>
                    </div>
                    <div
                        class="articleRow index-0 m-left"
                        data-aos="fade"
                        data-aos-delay="500"
                    >
                        <div>
                            <img
                                class="bottom-complete"
                                src="~@/assets/img/white-left.png"
                                alt=""
                            />
                        </div>
                        <div class="articleColumn-bottom">
                            <p class="text-big text-bold p3">
                                Para você, essa informação é:
                            </p>
                            <div
                                class="buttonVFRow p3"
                                :class="{ disabled: isSelected == true }"
                            >
                                <div
                                    v-for="(button, index) in buttons"
                                    :key="button.text"
                                    v-on:click="selectItem(index)"
                                    class="buttonVF text-bold"
                                    :class="{
                                        selectedVF: selectedIndex == index,
                                        correto: isSelected && index == 0,
                                        incorreto: isSelected && index == 1,
                                    }"
                                >
                                    {{ button.text }}
                                    <img
                                        v-if="
                                            isSelected &&
                                            button.text == 'Verdadeira'
                                        "
                                        class="feedback-icon"
                                        src="~@/assets/img/correto.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="
                                            isSelected && button.text == 'Falsa'
                                        "
                                        class="feedback-icon"
                                        src="~@/assets/img/incorreto.png"
                                        alt=""
                                    />
                                </div>
                            </div>
                            <div class="flex-col" v-if="isSelected">
                                <img
                                    class="img-VF"
                                    src="~@/assets/img/true.png"
                                    alt=""
                                    data-aos="zoom-in"
                                />
                                <p
                                    class="p2"
                                    data-aos="fade"
                                    data-aos-delay="1000"
                                >
                                    O RH trata e cuida de muitos dados pessoais e dados pessoais sensíveis na empresa.


                                </p>
                                <p
                                    class="p2"
                                    data-aos="fade"
                                    data-aos-delay="2500"
                                >
                                    Por isso, é importante
                                    <span class="text-bold"
                                        >evitar que informações pessoais sejam repassadas ou utilizadas sem o devido controle.</span
                                    >
                                </p>
                                <p
                                    class="p2 p4b"
                                    data-aos="fade-up"
                                    data-aos-delay="3000"
                                >
                                    Como garantir essa segurança?
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            isSelected: false,
            selectedIndex: -1,
            buttons: [
                {
                    text: "Verdadeira",
                },
                {
                    text: "Falsa",
                },
            ],
        };
    },
    methods: {
        selectItem(value) {
            this.selectedIndex = value;
            this.isSelected = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.page6 {
    padding-bottom: 50px;
    position: relative;
    background-image: url("~@/assets/img/page5-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position-x: -140px;
    height: 768px;

    .articleRow {
        .top-complete {
            position: absolute;
            left: -25px;
        }
        .bottom-complete {
            position: absolute;
            left: -20px;
            top: -273px;
        }
    }

    .articleColumn {
        &-top {
            background-color: $color-cerulean;
            padding-top: 140px;
            padding-bottom: 59px;
            height: 93px;
        }
        &-bottom {
            background-color: white;
        }
    }
    .active {
        .articleRow {
            .bottom-complete {
                position: absolute;
                left: -20px;
                top: 5px !important;
            }
        }
    }
    .conteudo-reverse {
        flex-direction: row;
        justify-content: flex-end;
        // .col1{
        //     width: 556px;
        // }
        .col2 {
            width: 556px;
            flex-grow: 5;
        }
    }

    @media (max-width: 1336px) {
        padding-left: 20px;
        padding-right: 20px;
        background-position: -450px;
    }

    @media (max-width: 1070px) {
        background-position: -525px;
    }
    @media (max-width: 1000px) {
        background-position: -630px;
    }

    @media (max-width: 900px) {
        padding-left: 20px;
        padding-right: 20px;
        height: auto;
        background-position: -330px;

        .conteudo-reverse {
            .col1 {
                display: none;
            }
            .col2 {
            }
        }
    }
    @media (max-width: 600px) {
        .conteudo-reverse {
            padding: 0;
            .col2 {
                padding: 0;
                margin: 0;
            }
        }
        .articleRow {
            .top-complete {
                display: none;
            }
            .bottom-complete {
                display: none;
            }
        }
        .articleColumn {
            &-top {
                height: auto;
                padding-right: 20px;
                padding-left: 20px;
                text-align: center;
                border-radius: 0 0 0 15px;
            }
            &-bottom {
                padding-right: 10px;
                padding-left: 10px;
                margin-right: 0;
            }
            .m-left {
                margin: 0;
            }
            .buttonVF {
                width: 42%;
            }
        }
    }
}
</style> 